/** @format */

import TooltipButton from '@atoms/TooltipButton';
import { ResourceStatus } from '@common/application/enums/ResourceStatus';
import { css } from '@emotion/react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useIntl } from 'react-intl';

interface FallbackIconProps {
  resourceStatus?: ResourceStatus;
  isImage?: boolean;
}

function FallbackIcon(props: FallbackIconProps) {
  const intl = useIntl();
  const getIconConfig = (resourceStatus?: ResourceStatus): { icon: IconProp; color: string; title: string; spin?: boolean; beat?: boolean } => {
    switch (resourceStatus) {
      case ResourceStatus.PENDING:
        return {
          title: intl.formatMessage({
            defaultMessage: 'This file is still being scanned for viruses, you can check if it is finished by refreshing the page. For larger files this may take several minutes.',
            description: 'A notification that a file or image is not yet ready to be viewed due to ongoing anti-virus checks',
          }),
          icon: ['fas', 'spinner'],
          color: 'var(--primary-500)',
          spin: true,
        };
      case ResourceStatus.QUARANTINE:
        return {
          title: intl.formatMessage({
            defaultMessage: 'This file has been marked as a potential virus and quarantined',
            description: 'Notification that a potential virus has been identified in the file that was uploaded',
          }),
          icon: ['fad', 'ban-bug'],
          color: 'var(--error-900)',
          beat: false,
        };
      case ResourceStatus.NULL:
        return {
          title: '',
          icon: ['fas', props.isImage ? 'image-slash' : 'file-slash'],
          color: 'var(--grey-300)',
          beat: false,
        };
      default:
        return {
          title: intl.formatMessage({ defaultMessage: 'An error was encountered while uploading this file. Please try again.' }),
          icon: ['fas', props.isImage ? 'image-slash' : 'file-slash'],
          color: 'var(--grey-300)',
          beat: false,
        };
    }
  };
  const fallbackIconConfig = getIconConfig(props.resourceStatus);

  if (!fallbackIconConfig.icon) {
    return null;
  }

  if (!fallbackIconConfig.title)
    return (
      <FontAwesomeIcon
        icon={fallbackIconConfig.icon}
        css={css`
          color: ${fallbackIconConfig.color};
          --fa-secondary-color: var(--black);
        `}
        spin={fallbackIconConfig.spin}
      />
    );

  return (
    <TooltipButton tooltip={fallbackIconConfig.title}>
      <FontAwesomeIcon
        beat={fallbackIconConfig.beat}
        icon={fallbackIconConfig.icon}
        css={css`
          color: ${fallbackIconConfig.color};
          --fa-secondary-color: var(--black);
        `}
        spin={fallbackIconConfig.spin}
        // title={fallbackIconConfig.title}
      />
    </TooltipButton>
  );
}

export default FallbackIcon;
